import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { SectionContainer } from './SectionContainer';
import { DragHandle } from './DragHandle';
import type { Section, Question, VisibilityCondition } from './types';

interface SortableSectionContainerProps {
  section: Section;
  questions: Question[];
  allQuestions: Question[];
  isReadOnly: boolean;
  onSectionChange: (sectionId: string, field: keyof Section, value: any) => void;
  onToggleCollapse: (sectionId: string) => void;
  onRemoveSection: (sectionId: string) => void;
  onAddQuestion: (sectionId: string) => void;
  onRemoveQuestion: (questionId: string) => void;
  onQuestionChange: (questionId: string, field: keyof Question, value: any) => void;
  onTypeChange: (questionId: string, type: string) => void;
  onOptionChange: (questionId: string, index: number, value: string) => void;
  onAddOption: (questionId: string) => void;
  onRemoveOption: (questionId: string, index: number) => void;
  onToggleCondition: (globalIndex: number) => void;
  onConditionChange: (globalIndex: number, field: keyof VisibilityCondition, value: any) => void;
  onConditionValueToggle: (globalIndex: number, value: string) => void;
  onToggleFlag: (questionId: string) => void;
  onFlagChange: (questionId: string, field: string, value: any) => void;
  onFlagValueToggle: (questionId: string, value: string) => void;
  getGlobalIndex: (question: Question) => number;
}

export const SortableSectionContainer: React.FC<SortableSectionContainerProps> = ({
  section,
  isReadOnly,
  ...rest
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: `s-${section.id}`, disabled: isReadOnly });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.4 : 1,
  };

  return (
    <div ref={setNodeRef} style={style}>
      <SectionContainer
        section={section}
        isReadOnly={isReadOnly}
        dragHandle={!isReadOnly ? <DragHandle attributes={attributes} listeners={listeners} /> : undefined}
        {...rest}
      />
    </div>
  );
};
